import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import SynopsysPolarisCredentialsForm from "./SynopsysPolarisCredentialsForm";
import SynopsysPolarisMappingForm from "./SynopsysPolarisMappingForm";
import ContentOverlay from "components/ContentOverlay";
import _ from 'lodash';
import { CellRenderers } from "utils/tableUtils";

export default function SynopsysPolarisConfigListing(props) {
  const columns = [
    {
      title: "PortfolioItem",
      dataIndex: "portfolioItemName",
      width: 240,
      render: (portfolio) => {
        if (_.isEmpty(portfolio)) {
          return CellRenderers.VALUE_OR_NA(portfolio)
        }

        const nameSpaces = _.split(portfolio, ',');
        const projectObj = {}

        _.forEach(nameSpaces, portfolio => {
          const index = portfolio.lastIndexOf(':')
          const _project = portfolio.substring(0, index === -1 ? undefined : index);
          if (index !== -1) {
            const references = portfolio.substring(index + 1, portfolio.length);
            projectObj[_project] = _.split(references.replace(/;/g, ', '), ',')
          } else {
            projectObj[_project] = undefined
          }

        })

        const renderName = Object.keys(projectObj).map(item => projectObj[item] ? `${item} - [${projectObj[item]}]` : item)


        const content = renderName.map(item => <p>{item}</p>)

        return <ContentOverlay content={content} minHeight={40} />
      }
    }
  ];
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={SynopsysPolarisMappingForm}
      CredentialsForm={SynopsysPolarisCredentialsForm}
      extraColumns={columns}
    />
  );
}
